import React from "react";
import { sepJustMoney } from "../../../Function";

const Order = ({ order }) => {
  const HandlerData = KEY => {
    switch (KEY) {
      case "trackingcodeorder":
        return {
          name: "کد پیگیری سفارش ",
          value: order[KEY],
        };
      case "model_order":
        return {
          name: "نوع سفارش",
          value: Rendertypeorder(order[KEY]),
        };
      case "growth_price":
        return {
          name: "مجموع مبلغ",
          value: sepJustMoney(order[KEY]) + " تومان ",
        };
      case "discount":
        return {
          name: "میزان تخفیف ",
          value: sepJustMoney(order[KEY]) + " تومان ",
        };
      case "total_price":
        return {
          name: "مبلغ پرداخت شده",
          value: sepJustMoney(order[KEY]) + " تومان ",
        };
      case "offer_code":
        return {
          name: "کد تخفیف",
          value: order[KEY] != null ? order[KEY] : "ندارد",
        };
      case "status":
        return {
          name: "وضعیت",
          value: Renderststus(order[KEY]),
        };
    }
  };
  const Rendertypeorder = type => {
    switch (type) {
      case "reserve":
        return "رزرواسیون";
      case "walletsharge":
        return "شارژ کیف پول";
      case "joinclass":
        return "ثبت نام در کلاس";
      case "contractual_reservation":
        return "رزرو قراردادی";
      case "contractual_reservation_installments":
        return " رزرو قراردادی باز پرداخت بازه ای";
    }
  };
  const Renderststus = type => {
    switch (type) {
      case "peyed":
        return "پرداخت شده";
      case "payerror":
        return "عدم پرداخت";
      case "used":
        return "استفاده شده";
      case "waittopay":
        return "پرداخت رها شده";
    }
  };
  return (
    <div style={{ marginBottom: "30px" }}>
      <div style={{ borderBottom: "1px solid red" }} className="mb-2">
        <h4 style={{ fontSize: "18px" }}>مشخصات سفارش</h4>
      </div>
      <div className="row justify-content-between px-2">
        {Object.keys(order).map(function (value, key) {
          if (HandlerData(value))
            return (
              <div
                key={key}
                className={`col-md-6 d-flex ${
                  window.innerWidth > 600
                    ? "justify-content-start"
                    : "justify-content-between"
                }   align-items-center `}
              >
                <div>
                  <span style={{ fontWeight: "500", fontSize: "14px" }}>
                    {HandlerData(value)["name"]} :
                  </span>
                </div>
                <div>
                  <span style={{ fontWeight: "400", fontSize: "14px",marginRight:"5px" }}>
                    {HandlerData(value)["value"]}
                  </span>
                </div>
              </div>
            );
        })}
      </div>
    </div>
  );
};

export default Order;
